import ForbesDashboardView from "src/sections/dashboards/platforms/forbes/forbes-dashboard-view";

const ForbesMainDashboardPage = () => <ForbesDashboardView type="main" />;

export default ForbesMainDashboardPage;
